import { Component, computed, inject, signal } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./images-dialog.component.scss'],
  template: `
    <div class="images-dialog-container">
      <div class="viewer-container">
        <button class="arrow left" (click)="previousImage()">&#10094;</button>

        <div class="main-image">
          <img [src]="currentImage()" alt="Preview" />
        </div>

        <button class="arrow right" (click)="nextImage()">&#10095;</button>
      </div>

      <p class="caption">Image {{ currentIndex() + 1 }} of {{ images().length }}</p>

      <div class="thumbnails">
        @for (image of images(); track trackByImage(i, image); let i = $index) {
          <img [src]="image" [class.active]="i === currentIndex()" (click)="setCurrentIndex(i)" />
        }
      </div>
    </div>
  `,
})
export class RecommendationImagesDialogComponent {
  readonly currentIndex = signal(0);
  readonly images = signal<string[]>([]);
  readonly currentImage = computed(() => this.images()[this.currentIndex()]);

  readonly config = inject(DynamicDialogConfig);

  constructor() {
    this.images.set(this.config.data?.images ?? []);
  }

  nextImage() {
    this.currentIndex.update((index) => (index + 1) % this.images().length);
  }

  previousImage() {
    this.currentIndex.update((index) => (index - 1 + this.images().length) % this.images().length);
  }

  setCurrentIndex(index: number) {
    this.currentIndex.set(index);
  }

  trackByIndex(index: number): number {
    return index;
  }

  trackByImage(index: number, image: string): string {
    return image;
  }
}
